import { createSelector } from 'reselect'
import { selectIsSubscriptionActive } from './selectIsSubscriptionActive'
import { selectIsBillingAccountActive } from './selectIsBillingAccountActive'
import { selectUpcomingInvoiceItems } from './selectUpcomingInvoiceItems'
import { selectUpcomingInvoice } from './selectUpcomingInvoice'
import { selectBillingAccount } from './selectBillingAccount'

export const selectBillingEstimate = createSelector(
  selectBillingAccount,
  selectUpcomingInvoice,
  selectUpcomingInvoiceItems,
  selectIsBillingAccountActive,
  selectIsSubscriptionActive,
  (
    billingAccount,
    upcomingInvoice,
    upcomingInvoiceLines,
    isBillingAccountActive,
    isSubscriptionActive
  ) => {
    return {
      isAccountActive: isBillingAccountActive,
      isSubscriptionActive,
      hasInvoice: !!upcomingInvoice.id,
      nextBillDate: upcomingInvoice.nextPaymentAttempt,
      subscriptionCharges: upcomingInvoiceLines
        .filter(item => !item.proration)
        .reduce((total, item) => item.amount + total, 0),
      prorataCharges: upcomingInvoiceLines
        .filter(item => item.proration)
        .reduce((total, item) => item.amount + total, 0),
      creditBalance: billingAccount.creditBalance,
      total: upcomingInvoice.amountDue,
      currency: upcomingInvoice.currency,
    }
  }
)
